<template>
  <v-btn
    v-scroll="onScroll"
    v-show="fab"
    fab
    dark
    fixed
    bottom
    right
    color="#E8320D"
    @click="toTop"
    class="scroll-top-btn"
  >
    <v-icon>{{ iconArrow }}</v-icon>
  </v-btn>
</template>

<script>
import { mdiArrowUp } from '@mdi/js';

export default {
  name: 'scrollTopBtn',
  data() {
    return {
      iconArrow: mdiArrowUp,
      fab: false
    };
  },
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0, { container: document.documentElement });
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 400px) {
  .scroll-top-btn {
    right: 16px !important;
  }
}
</style>
